import {Ad, Member, Menu, Offer, Store, Link} from 'aigens-ng-core';
import {Session} from '../../../../core/data/session';
import {Component, Injector, OnInit, ChangeDetectorRef} from '@angular/core';
import {ProfilePage} from '../../profile/profile';
import {MobileBasePage} from '../../../../core/base/mobile-base-page';
import {RewardListPage} from '../../reward-list/reward-list-page';
import {PromotionDetailPage} from '../../promotion-detail/promotion-detail-page';
import {isAvailableOffer} from '../../../../shared/utilities/checkFormatTool';
import {TermsConditionsPage} from '../../../../dialogs/terms-conditions/terms-conditions';
import {getCategoryPage} from '../../../../shared/utilities/layout-helper';
import {RewardListDialog} from '../../../../dialogs/reward-list/reward-list';

/*
  Generated class for the Home page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
    selector: 'page-member-reward',
    templateUrl: 'member-reward-court.html',
    styleUrls: ['member-reward-court.scss']
})
export class MemberRewardCourtPage extends MobileBasePage implements OnInit {

    ads: Ad[] = [];
    code: string;
    session: Session;
    offers: Offer[] = [];
    startPoint = 0;
    endPoint = 380;
    qaOpened = false;
    // rewards:any[] = [];
    animateNum: boolean;
    loop: any;
    numStart = 0;
    numEnd = 380;
    count: number = this.numStart;
    increment = 10;
    hasCrmId: boolean;

    pointFeature = false;

    pointsToUse: any = null;

    isBounce = false;

    screenWidthUnit: String;
    badgeNum = 0;
    member: Member;

    enableStamps = false;
    totalStamps: any[] = [];
    stamps = 0;
    totalStampsCount = 10;
    brand;
    sagmentValue:string = 'reward'
    constructor(private injector: Injector, private cd: ChangeDetectorRef) {

        super(injector);
        this.initTotalStamps();
        let brand = this.getNavParams('brand');
        this.ads = brand && brand.ads.filter(ad => ad.type !== 'popup');
        this.hasCrmId = !!brand['crmId'];
        if (this.memberService.offers) {
            this.offers = this.memberService.offers;
        }

        this.getApi(brand);
        // const store_ = this.orderService.store;
        this.pointFeature = brand && brand['crm'] && brand['crm']['addPoints'] || false;
        this.enableStamps = brand && brand['crm'] && brand['crm']['addStamps'] || false;
        this.brand = brand;
        this.sagmentValueInit();
    }
    sagmentValueInit(){
        if(this.offers.length > 0) {
            this.sagmentValue = 'reward';
        } else if(this.enableStamps) {
            this.sagmentValue = 'stamps';
        } else if(this.enableStamps) {
            this.sagmentValue = 'promotion';
        }
    }
    segmentChanged(ev: any) {
        console.log('Segment changed', ev);
        this.sagmentValue = ev.detail.value;
        this.cd.detectChanges();
      }
    getApi(brand) {
        this.loading(true);
        Promise.all([this.getMember(brand), this.getCourtReward()]).then(resluts => {
            this.loading(false);
            if (!resluts) {
                return;
            }
            /// update  this.configService.getMember()
            const member = this.memberService.getMember();
            const memberships: any = resluts[0];

            const has = (memberships && memberships instanceof Array && memberships.length > 0);
            if (has) {
                member.membership = memberships[0];
                this.updateStamps(member.membership['stamps']);
            }
            // this.member = member;

            if (this.memberService.member && this.pointFeature) {
                this.numEnd = this.memberService.member.membership && this.memberService.member.membership.usablePoints ? this.memberService.member.membership.usablePoints : 0;
                // this.numEnd = 6009; //9990909901
                this.increment = this.numEnd;
                let time = 10;
                while (this.increment / 10 > 1) {
                    time = time * 10;
                    this.increment = this.increment / 10;
                }

                const countFactor = this.increment > 7 ? 5 : (this.increment > 5 ? 2 : 1);
                this.increment = time * countFactor / 100;

                /// fixed ,等html 加載完成,否則document.getElementById('point') 可能為 null
                setTimeout(() => {
                    this.displayLoop();
                }, 500);

            }


            const offers: any = resluts[1];
            if (offers instanceof Array) {
                this.offers = offers;
                this.memberService.offers = this.offers;
            }


        }).catch(err => {
            this.loading(false);
            if (err && err.status && err.status === 401) {
                this.showAlert(err.status, err['_body'], [{
                    text: this.t.instant('buttons.ok'),
                    handler: () => {
                        this.memberService.clear();
                        this.navigationService.popToRoot();
                    }
                }]);

            } else {
                this.showError(err);
            }
        });
    }

    logout() {
        this.showAlert('', this.t.instant('pages.profile.alert-title'), [{
            text: this.t.instant('buttons.no'),
            handler: () => {
                console.log('cancel');
            }
        }, {
            text: this.t.instant('buttons.yes'),
            handler: () => {
                this.memberService.clear();
                this.orderService.logoutClear();
                this.popToRoot();

            }
        }]);

    }

    backButtonClick() {
        this.navigationService.popToRoot();
    }

    // 由于html模板里无法直接使用Import进来的方法，这里包装一下。或者使用继承MobileBasePage
    isAvailableReward(offer) {
        return isAvailableOffer(offer);
    }

    displayLoop() {
        let temp = document.getElementById('point');
        if (temp) {
            document.getElementById('point').innerHTML = `<span>` + this.count + `</span>`;
        }

        if (this.count < this.numEnd) {
            this.loop = setTimeout(() => {
                this.displayLoop();
            }, 30);
            if (this.increment > 0 && this.numEnd - this.count > this.increment) {
                this.count += this.increment;
            } else {
                this.count++;
            }
        }
    }

    ngOnInit() {
        console.log('ngOnInit HomePage');
        // this.displayLoop();

    }

    redeem(i) {
        // if(i === 0 && this.orderService.redeemedReward.length <= 0){
        // this.showAlert("Do you want to redeem?","",[{
        //     text: "No",
        //     handler: () => {

        //     }
        // },{
        //     text: "Yes",
        //     handler: () => {
        //             this.orderService.redeemedReward.push(this.orderService.rewards[i]);
        //             this.orderService.rewards.splice(i,1);
        //             this.badgeNum ++;
        //             this.isBounce = true;
        //             setTimeout(()=>{this.isBounce=false;},800);
        //         }
        //     }]);

        // }

    }

    goProfile() {
        this.pushByName('ProfileCourtPage', {isEditMode: false});
    }

    openRewardList(offer) {
        this.pushByName('RewardListPage', {offer: offer});


    }

    qaBoxEvent() {
        this.qaOpened = !this.qaOpened;
        console.log(this.qaOpened);
    }

    redeemReward(offer) {
        if (isAvailableOffer(offer)) {
            if (!this.orderService.spot && this.selectOrderModeAlert(offer)) {
                return;
            }
            this.pushToNext(offer);
        }
    }

    startOrder() {
        if (!this.orderService.spot && this.selectOrderModeAlert()) {
            return;
        }
        this.pushToNext();
    }

    selectOrderModeAlert(offer?): boolean {
        if (this.orderManager.mode === 'preorder' || this.orderManager.mode === 'dinein' || this.orderManager.mode === 'takeaway') {
            console.log('no need to select mode');
            return false;
        }
        // TODO: check court mode?
        if (!this.orderManager.store) {
            console.warn('no store', this.orderManager);
            return false;
        }

        if(!this.isPopupModeSelectModalAccordingToStoreMenuMode(this.orderManager.store)){
            return false;
        }
        
        let alert = this.showModeAlert(offer);
        alert.then(a => a.present());

        return true;

    }

    async showModeAlert(offer?: Offer) {
        return await this.alertController.create({
            header: this.t.instant('pages.splash.prompt-dine-mode'),
            backdropDismiss: false,
            buttons: [
                {
                    text: this.t.instant('pages.splash.dine-in'),
                    handler: () => {
                        // to do
                        // this.googleAnalyticEventTrack()
                        this.orderManager.mode = 'dinein';
                        this.pushToNext(offer);

                    }
                },
                {
                    text: this.t.instant('pages.splash.takeout'),
                    handler: () => {
                        // to do
                        // this.googleAnalyticEventTrack();
                        this.orderManager.mode = 'takeaway';
                        this.pushToNext(offer);

                    }
                }
            ]
        });
        // alert.then(data => data.present());
    }

    goToPromotion(ad: Ad) {
        if (ad['links'] && (ad['links']['default'] || ad['links']['app'])) {
            this.pushByName('PromotionDetailPage', {ad: ad});
        }
    }

    initTotalStamps() {
        // default = 10;
        let tmps = [];
        for (let i = 0; i < this.totalStampsCount; i++) {
            let stamp = {active: false, index: i, showNumber: i + 1};
            tmps.push(stamp);
        }
        this.totalStamps = tmps;
    }

    updateStamps(stampCount: number) {
        if (isNaN(stampCount)) {
            return;
        }
        let limit = Math.min(stampCount, this.totalStamps.length);
        for (let i = 0; i < limit; i++) {
            this.totalStamps[i]['active'] = true;
        }
    }

    handleEffectiveStamp(effectiveCount: number) {
        if (isNaN(effectiveCount)) {
            return;
        }
        this.stamps = effectiveCount;
        let count = Number(effectiveCount);
        this.totalStamps.forEach(s => {
            let showNumber = Number(s.showNumber);
            // reset
            s.active = false;
            if (showNumber <= count) {
                s.active = true;
            }
        });
    }

    clickedStamp(stamp: any, index: number) {
        console.log('stamp index', stamp, index);
        let number = index + 1;
        // if (stamp.active && number == 5) {
        //     console.log("clicked 5..");
        // }
    }

    clickedRedeem(stamp) {

    }

    onRewardListClick() {
        this.memberApiService.getRedeemableRewards(this.brand.id).subscribe((rewards) => {
            const input = {rewards: rewards};
            // TODO: enter animation using animated or enterAnimation?
            this.modalController.create({
                component: RewardListDialog,
                componentProps: input,
                showBackdrop: true,
                backdropDismiss: true,
                cssClass: 'modal-largescreen',
                animated: true
            }).then(modal => {
                modal.onWillDismiss().then(reward => {
                    // TODO: is this
                    console.log('reward', reward);
                    if (reward) {
                        this.memberApiService.redeemReward(this.orderManager.store.brandId, reward.data.id).subscribe(data => {
                            console.log('reward redeemed', data);
                            this.getApi(this.orderManager.store);
                        });
                    } else {
                        console.log('no reward redeemed');
                    }
                });
                modal.present();
            });

        });
    }

    private getCourtReward() {
        return new Promise((resolve, reject) => {
            this.orderService.getCourtReward().subscribe(offers => {
                resolve(offers);
            }, err => {
                console.log('getReward error', err);
                reject(err);
            });
        });
    }
    private  getTandCUrl(brand, name: string): string {
        if (!brand.links) {
            return null;
        }
        const link = brand.links[name] as Link;
        if (!link) {
            return null;
        }

        let url = link.url;

        if (!url) {
            return null;
        }

        if (url.indexOf('http://') === 0 && url.indexOf('localhost') === -1) {
            url = url.replace('http:', 'https:');
        }

        return url;
    }

    private getMember(brand) {
        return new Promise((resolve, reject) => {
            this.memberApiService.checkingMembership(brand.id).subscribe(async (memberships) => {

                console.log('calling membership', memberships, this.memberService.member);
                resolve(memberships);
                if (!memberships || memberships.length === 0) {
                    // prompt alert for asking membership
                    const url = this.getTandCUrl(brand, 'byodTc');
                    let isFb = false;
                    let handler = (handle) => {
                        if (handle['fail'] === 'failed') {
                            this.memberService.clear();
                            this.navigationService.popToRoot();

                        } else {
                            // do membership here
                            let marketing = false;
                            marketing = handle['marketing'];
                            let marketingOrderPlace = false;
                            marketingOrderPlace = handle['marketingBrand'];
                            this.loading(true);
                            this.memberApiService.join(null, this.brand.id, marketing).subscribe((result) => {// court 的话 storeId pass null
                                this.loading(false);

                            }, (err) => {
                                this.loading(false);
                            });
                        }

                    };
                    // if (this.memberService.member['source'] === "ascentis") {
                    //     return
                    // }
                    // if (url) {
                    //     const params = { url: url, needToAgreeMarketing: true };
                    //     if (isFb) { // isFb=false
                    //         params['fbHandler'] = handler;
                    //     }
                    //     params['brandName'] = brand.name;
                    //     const modal = await this.modalController.create({ component: TermsConditionsPage, componentProps: params, backdropDismiss: false });
                    //     modal.onDidDismiss().then((result) => {
                    //         console.log('tnc result', result.data);
                    //         if (result && handler && !isFb) {
                    //             handler(result.data);
                    //         }
                    //     });

                    //     modal.present();

                    // } else {
                    //     console.warn('Please add Terms and Conditions');
                    //     this.loading(false);
                    //     this.showAlert(this.t.instant('pages.base.missing-tnc'), '');
                    // }

                }
            }, err => {
                console.log('checkingMembership error', err);
                reject(err);
            });
        });
    }

    private pushToNext(offer?: Offer) {
        this.menuManager.clearAvailableMap();
        // TODO: use this as default layout?
        // call general start order function here
        // i.e set up order manager, settings, etc.
        // this.initOrder();
        this.pushAndRemovePage('BrandStoreListPage', {
            courtId: this.brand.id
        }, null, () => {
            if (offer) {
                this.clickReward(offer, this.orderManager.store, 'ItemGridPage');
            }

        });
    }


}
